import React from 'react'

import TextField from '@mui/material/TextField'

interface CommentEditorProps {
  label: string
  commentText: string
  onChange: (newText: string) => void
}

const CommentEditor = (props: CommentEditorProps): JSX.Element => {
  return (
    <TextField
      sx={{ mt: 2, mb: 1 }}
      label={props.label}
      fullWidth
      multiline
      minRows={2}
      value={props.commentText}
      onChange={(event) => props.onChange(event.target.value)}
    />
  )
}

export default CommentEditor
